import * as config from '../config';
import StepModel from '../models/step';
import OptionsController from './options';
import JumpsController from './jumps';

export default class StepsController {
  constructor(graph, style, steps) {
    this.graph = graph;
    this.style = style;
    this.steps = steps;
    this.step = {};
  }

  initialize() {
    this.steps.forEach(step => {
      this.step = new StepModel(step);
      const options = new OptionsController(this, this.step);
      const jumps = new JumpsController(this, this.step);

      this.draw(this.step);

      if (options.show()) {
        return options.draw();
      }

      if (jumps.show()) {
        return jumps.draw();
      }

      if (this.step.isText()) {
        return jumps.drawConnection(this.step.id);
      }

      return this.removeThanksWithoutConnections();
    });
  }

  draw(step) {
    this.graph.addNode(step.id, step.label);
    this.style.bindIdToClass(step.id, config.STEP_CLASSES[step.kind]);
  }

  getNextId(step, jump) {
    const destinationId = this.getDestinationId(jump);

    if (destinationId) {
      return destinationId;
    }

    const next = this.steps[step.position + 1];

    if (next) {
      return next.id;
    }

    return null;
  }

  getDestinationId(jump) {
    return jump.destinationStepId || jump.destination_step_id;
  }

  hasConnections() {
    return this.graph.nodeHasEdge(this.step.id);
  }

  remove() {
    this.graph.removeNode(this.step.id, this.step.label);
  }

  removeThanksWithoutConnections() {
    if (this.step.isThanks() && !this.hasConnections()) {
      this.remove();
    }
  }
}



/** WEBPACK FOOTER **
 ** ./src/helpers/fluxogram/controllers/steps.js
 **/